import src from "./esquire.svg";
export default { src: src, aspect: 6.315789473684211, width: 120, height: 19 };